import $ from 'domtastic'
import gsap from 'gsap'
import SplitText from '@js/vendors/gsap/SplitText.min'

import { unwrapLine } from '@utils/utils'
import ScrollTrigger from 'gsap/ScrollTrigger'




/* AUTO WOOSH ON SCROLL
---------------------------------------------------------------------------------------------------- */

export default class Woosh {

    constructor($ctn) {
        this.$ctn = $ctn

        this.splitTexts = getsplitTexts(this.$ctn.find('[data-split]:not(.visually-hidden):not(.sr-only)'))
    }


    init() {
        this.splitText()
        this.scrollTrigger()
    }



    /* Actions
    --------------------------------------------------------- */

    splitText() {
        this.splitTexts.forEach((t) => {
            if (t.displayed) return

            clearSplitText(t.$el[0], this.splitTexts)

            const charsType = APP.Layout.isMobile ? 'words, chars' : 'lines, chars'
            const type = t.$el[0].dataset.split.length ? t.$el[0].dataset.split : charsType

            t.split = new SplitText(t.$el, { type, wordsClass: 'splittedWord', charsClass: 'splitChar', linesClass: 'splittedLine' })
            // t.split.chars.forEach((l) => { wrap(l, $('<span class="split-charCtn">')[0]) })

            if (t.$el[0].dataset.splitAttr) {
                t.split.lines.forEach((line, i) => {
                    Object.entries(JSON.parse(t.$el[0].dataset.splitAttr)).forEach(([key, v]) => {
                        line.setAttribute(key, JSON.stringify(v))
                    })

                    gsap.set(line, { '--line': i + 1 })
                })
            }

            t.$el.addClass('is-ready')
        })
    }


    scrollTrigger() {
        if (APP.Browser.reducedMotion) return

        const animKeys = Object.keys(animationLibrary)
        const selector = animKeys
            .map(k => `[data-${k}]:not([data-st]):not(.visually-hidden):not(.sr-only)`)
            .join(',')



        this.scrollTriggers = this.$ctn.find('[data-st]').forEach((trigger) => {
            const $children = [...trigger.querySelectorAll(selector)]

            if (Object.keys(trigger.dataset).some(e => Object.keys(animationLibrary).includes(e))) {
                $children.unshift(trigger)
            }

            const startString  = trigger.dataset.st || 'top bottom'
            const startTrigger = Number.isNaN(parseInt(startString, 10)) ? startString : parseInt(startString, 10)

            $children.forEach(($el, i) => {
                const keyAnim = Object.keys($el.dataset).filter(s => Object.keys(animationLibrary).includes(s))


                // keyAnim.forEach((anim) =>)
                keyAnim.forEach((anim) => {
                    const { tween, config = {} } = animationLibrary[anim]($el, trigger)

                    ScrollTrigger.create({
                        trigger,
                        animation : tween,
                        start     : config.start || startTrigger,
                        end       : config.end,
                        markers   : $el.hasAttribute('data-markers'),

                        ...config,
                    })
                })




                // return { keyAnim, $section: el, $el, st }
            })
        })
    }


    resize() {
        this.splitText()
        // this.scrollTrigger()
    }



}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */

const clearSplitText = ($el, splitRefs = []) => {
    const st = splitRefs.find(e => e.$el.get(0) === $el)

    if (!st || !st.split.chars) return

    st.split.chars.forEach((c) => { unwrapLine(c) })
    st.split.revert()
}


const getsplitTexts = sel => Array.from(sel).map(title => ({
    $el   : $(title),
    split : {},
    displayed: false,
}))


const animationLibrary = {
    plx: ($el, $parent) => ({
        tween: gsap.fromTo(
            $el,
            { ...JSON.parse($el.dataset?.plxFrom || '{}') },
            { ...JSON.parse($el.dataset.plx), ease: 'none' },
        ),
        config: {
            scrub: 0.8,
            end: $parent.dataset.stEnd || 'bottom top',

            onToggle: ({ isActive }) => {
                gsap.set($el, { willChange: isActive ? 'transform' : '' })
            },
        },
    }),

    reveal: $el => ({
        tween: (() => {
            const config = JSON.parse($el.dataset.reveal || '{}')
            const clearValues = Object.keys(config).join(',')

            return gsap.from(
                $el,
                {
                    ease: 'power3.out',
                    duration: 0.6,
                    force3D: true,
                    ...config,
                    clearProps: clearValues,
                },
            )
        })(),
    }),
}
